import httpClient from '@/api/httpClient';

import { PRODUCTS_ENDPOINT } from '@/constants/endpoints';

const getProductsList = () => httpClient.get(`${PRODUCTS_ENDPOINT}/all`);

export { getProductsList };
